import { addTokenToUrl, ApiClient } from "@/services/apiClient";
import { type AxiosResponse } from "axios";

export async function hidePrices(): Promise<AxiosResponse> {
  const url = addTokenToUrl("accounts/hide-prices");
  return ApiClient.post(url);
}

export async function showPrices(): Promise<AxiosResponse> {
  const url = addTokenToUrl("accounts/show-prices");
  return ApiClient.post(url);
}
